import { faMemoCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

export interface IProjectActualsIconProps {
    name: string;
    className?: string;
}

const ProjectActualsIcon = ({ name, className }: IProjectActualsIconProps) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const toggleTooltip = () => {
        setOpenTooltip(!openTooltip);
    };

    return (
        <div className={className}>
            <FontAwesomeIcon
                id={`${name}-tooltip`}
                icon={faMemoCircleCheck}
            />
            <Tooltip
                target={`${name}-tooltip`}
                isOpen={openTooltip}
                toggle={toggleTooltip}
                placement="top"
            >
                <div>This field has been updated based on project data.</div>
            </Tooltip>
        </div>
    );
};

export default ProjectActualsIcon;
